// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/BespokeIFrame/index.css
// module id = 3035
// module chunks = 0